import React, { useState, useCallback, Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import { Button } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';

import { t } from '~/helpers';
import api from '~/services/api';
import { recordFiltering } from '~/store/modules/notasFiscaisRecebidas/actions';

import * as S from './styles';

export default function Toolbar() {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const { params } = useSelector((state) => state.notasfiscaisrecebidas);

  const handleOnFileUpload = useCallback(
    async (file) => {
      try {
        setLoading(true);

        const data = new FormData();

        data.append('file', file, file.name);

        await api.put('/nf/uploadnf', data);

        toast.success('Arquivo enviado com sucesso!');
      } catch (error) {
        if (isArray(error)) error.map((err) => toast.error(t(err)));
        else toast.error(t(error));
      } finally {
        inputRef.current.value = null;

        setLoading(false);
        dispatch(recordFiltering(params));
      }
    },
    [params]
  );

  return (
    <Fragment>
      <S.FileUpload
        type="file"
        name="file"
        id="invoice"
        accept="text/xml"
        ref={inputRef}
        onChange={({ target }) => handleOnFileUpload(target.files[0])}
      />

      <S.Wrapper htmlFor="invoice">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<AttachFile />}
          disabled={loading}
        >
          Upload
        </Button>
      </S.Wrapper>
    </Fragment>
  );
}
